import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import { darken, lighten, alpha } from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';

import { v4 as uuidv4 } from 'uuid';

import {DndContext, useDroppable, useDraggable, DragOverlay} from '@dnd-kit/core';
import {closestCorners, closestCenter, rectIntersection} from '@dnd-kit/core';
import {PointerSensor, MouseSensor, TouchSensor, useSensor, useSensors} from '@dnd-kit/core';

import Bs4Kartoteka from '../Bs4Kartoteka'
import Bs4MainDispatch from '../Bs4MainDispatch';
import Bs4ReportGeneric from './Bs4ReportGeneric';
import Bs4Criteria from './Bs4Criteria'
import Bs4CriteriaSummary from './Bs4CriteriaSummary'
import Bs4I18N from '../Bs4I18N';
import Tooltip from '@mui/material/Tooltip';
import Bs4Tooltip, { Bs4HtmlTooltip, Bs4Tooltip01 } from '../Bs4Components/Bs4Tooltip';

import { getBoxSx, useStateUxTemplate } from '../Bs4Theme/Bs4UxTemplates';

const DRAGDROPSECTION = 'dragDropSection';
const ID_SEPARATOR = '_';
const SHAPE_ENDING = 'ending';
const EDIT_VIEW_ID = 'Bs4ViewItemMessageEdit'
const TYPE_BS4REPORTTYPE53 = 'type_Bs4ReportType53';

//Program trigger
export default class Bs4ReportType53 extends Bs4ReportGeneric {

  createModel() {
    super.createModel();
    this.rootItem = this.newItem({color: '', id: 0, name: 'Main', section: '-1', shape: 'main'});
    this.dragDropSection = this.getPageParam(DRAGDROPSECTION);
    this.libraryItems = [];
    this.dragDropSection.elements.forEach(element => {
      this.libraryItems.push(this.newItem(element));
    });
  }

  text_Delete = Bs4I18N.getTT("Delete", 'Usuń', 'Bs4ReportType53');

  ActiveItemContext = React.createContext({});
  itemNextId = 1;
  getNextIdItem = () => String(this.itemNextId++);
  rootItem = null;

  newItem = (element) => {
    const item = {
      element: element,
      id: this.getNextIdItem(),
    };

    switch(element.shape) {
      case 'main':  
        item.programs = ['main'];
        item.id = '0';
        break;

      case 'if':  
        item.programs = ['then'];
        break;

      case 'ifelse':
        item.programs = ['then', 'else'];
        break;

      default:
        item.programs = [];
        break;
    }  
    item.programs.forEach(program => item[program] = [])    
    return item;
  }

  getItem = (parent, id) => {    
    for (const program of parent.programs) {
      let after = null;
      for (const item of parent[program]) {
        if (item.id === id) {
          item.lastLocation = {parent: parent, program: program, after: after};
          return item;
        }
        const getedItem = this.getItem(item, id);
        if (getedItem) return getedItem;      
        after = item;
      }      
    }
  }

  removeItem = (parent, id) => {    
    for (const program of parent.programs) {
      let after = null;
      for (const item of parent[program]) {
        if (item.id === id) {
          parent[program] = parent[program].filter(item => item.id !== id);
          item.lastLocation = {parent: parent, program: program, after: after};
          return item;
        }
        const removedItem = this.removeItem(item, id);
        if (removedItem) return removedItem;
        after = item;
      }
    }
  }

  insertItem = (parent, parentId, parentProgram, afterId, newItem) => {
    if (parent.id === parentId) {
      if (!(parentProgram in parent)) {
        console.log('...DND...insertItem...error... !(parentProgram in parent) ', parent, parentId, parentProgram, afterId, newItem)
        return;
      }
      if (afterId) {
        const children = parent[parentProgram];
        parent[parentProgram] = [];
        for (const item of children) {
          parent[parentProgram].push(item);
          if (item.id === afterId) parent[parentProgram].push(newItem);
        }
      } else {
        parent[parentProgram].unshift(newItem);
      }
      return parent;
    }

    for (const program of parent.programs) for (const item of parent[program]) {
      const itemParent = this.insertItem(item, parentId, parentProgram, afterId, newItem);
      if (itemParent) return itemParent;
    }
  }

  sortCollisionsAsc = ({data: {value: a}}, {data: {value: b}}) => a - b;
  
  customCollisionDetectionAlgorithm = (props) => {
    const {droppableContainers, droppableRects, ...args} = props
    
    const collisions = [];

    for (const droppableContainer of droppableContainers) {

      const {id} = droppableContainer;
      const rect = droppableContainer.node.current.getBoundingClientRect();
      if (rect) {
        const x = rect.left - args.collisionRect.left;
        const y = rect.top - args.collisionRect.top;
        const v = Math.sqrt((x * x) + (y * y));              
        if (rect.left < args.collisionRect.left && rect.right > args.collisionRect.left && rect.top < args.collisionRect.top && rect.bottom > args.collisionRect.top) {
          collisions.push({id, data: {droppableContainer, value: 0}});
        } else {
          if (v < 50 || (droppableContainers.length < 3 && x < 50)) collisions.push({id, data: {droppableContainer, value: v}});
        }
      }
    }

    const ccc = collisions.sort(this.sortCollisionsAsc);
    return ccc;
  };

  /////////////////// form field ///////////////////////////
  getValue() {
    return null;
  }

  resetOriginalValue() {
  }

  isDifferentValues (oldValue, newVaue) {
    return false;
  }

  clear() {
  }
  //////////////////////////////////////////////////////////
  
  static SORT_DIR_ASC = 'ASC';
  static SORT_DIR_DESC = 'DESC';

  defaultUxTemplate = {
    class: 189,
    name: 'Bs4ReportType53',
    body: {        
      Report53: {
        panel: {
          backgroundColor: "rgba(255, 255, 255, 1)",
          margin: 1,
          padding: 1,
          elevation: 2,
          borderRadius: 1,
        },         
      },        
    },
  };

  getUxTemplateEditor = (uxEditor) => {

    return [{
      label: 'Report53',
      onReset: () => this.uxTemplate.body.Report53.panel = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.Report53.panel)),
      getUxTemplate: () => this.uxTemplate,
      setUxTemplate: this.setUxTemplate,      
      types: [TYPE_BS4REPORTTYPE53],
      Content: (props) => {
        const uxBody = this.uxTemplate.body.Report53;
        const type = TYPE_BS4REPORTTYPE53;
        const {} = useStateUxTemplate(type);

        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
              <uxEditor.ViewCssColor types={type} value={uxBody.panel} name='color' title='Tekst'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.panel} name='backgroundColor' title='Tło'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.panel} name='borderColor' title='Ramka'/>
            </Stack>                                  
            
            <uxEditor.ViewCssShadow types={type} value={uxBody.panel} name='elevation'/>
            <uxEditor.ViewCssText types={type} value={uxBody.panel} name='borderRadius'/>
            <uxEditor.ViewCssText types={type} value={uxBody.panel} name='borderWidth'/>

            <uxEditor.ViewCssText types={type} value={uxBody.panel} name='widthMargin' title='width'/>
            <uxEditor.ViewCssText types={type} value={uxBody.panel} name='margin'/>
            <uxEditor.ViewCssText types={type} value={uxBody.panel} name='padding'/>
          </Box>
        );
      },
    }]
  }

  sorters = {field: null, dir: null};

  reload = () => {
    //console.log('....Type49 Reload...')
    this.fetchMore()
  }

  getColumns() {
    const column = this.getColDef();
    // for (const column of this.getColDef()) {
    //   console.log('... Type 49 ... COLUMN', column)
    // }

    return column;
  }

  getColumnWidth() {
    for (const column of this.getColDef() || []) {
      return parseInt(column.width) || 200;
    }
  }

  fetchCriteriaVals() {
		const filterCriteria = this.defaultCriteriaVals();    				
		if (this.remembersettings) filterCriteria.remembersettings = 1;
		filterCriteria.newGridDesign = this.packColumnLayout();	// zapamietany uklad kolumn
		return filterCriteria;
	}

  packColumnLayout() {
    const tablica = this.getColDef().map((column, index) => {
      return {
        dataIndex: column.dataIndex,
        hidden: false,
        id: column.dataIndex, 
        index: index + 1,
      }
    })
    
    return JSON.stringify(tablica);
  }

  fetchMore() {
    const baseValues = this.fetchCriteriaVals(); //this.defaultCriteriaVals();    
    baseValues.page = parseInt(this.bs4PageProps.currentPage) || 0;
    baseValues.start = baseValues.page * this.bs4PageProps.paglim;
    baseValues.limit = this.bs4PageProps.paglim;
    if (this.sorters.field) {
      baseValues.sort = this.sorters.field;
      baseValues.dir = this.sorters.dir;
    }

    const newBaseValues = Bs4MainDispatch.getParserParams(baseValues, this.bs4KartotekaId);
    const formData = new FormData();
    for (let [key, value] of Object.entries(newBaseValues)) formData.append(key, value);
    fetch(Bs4MainDispatch.getUrlPath('web.php?com=Bs4ReportData'), {method: 'POST', body: formData})
    .then(response => response.text())
    .then(returnedText => {
      try {
        const returnedJson = JSON.parse(returnedText);               
        Bs4MainDispatch.parsingBs4Response(returnedJson, this.bs4KartotekaId);
        const data = returnedJson.treestorebs4data.map(record => {
          record.id = record.id || uuidv4();                    
          return record;
        })
                
        if (this.setData) this.setData(data);     
        this.bs4PageProps.inProgress = false;
      } catch (error) {
        console.log(returnedText);
        console.log(error);
      }
    })
    .catch((error) => {
      console.error(error);
    });
  }

  itemClick(bs4Item) {    
    if (!bs4Item) return;
    console.log('... itemClick ...', bs4Item)
		if(this.getPageParam('row_active_click')) {		 
      Bs4MainDispatch.commandParser('Bs4RowClick', { rowObjectId: bs4Item.id, currFormId: this.formId }, this.bs4KartotekaId);
		}			
  }

  itemAdd = (item) => {    
    //bs4SaveTrigger
    // - 'command_type' - id typu klocka
    // - 'add_after' - jeśli inne niż 0, upuszczenie nastąpiło za istniejącym elementem o podanym id
    // - 'parent' - jeśli inne niż 0, upuszczenie nastąpiło jako pierwsze dziecko wewnątrz gałęzi/elementu parent (czyli ma to być pierwsza w kolejności komenda w if/while/foreach o podanym id)
    // - 'parentelse' - jeśli inne niż 0, upuszczenie nastąpiło jako pierwszego w kolejności elementu w sekcji else elementu o typie ifelse
    // - jeśli jest tylko command_type a pozostałe są 0, to upuszczony element ma być pierwszym w kolejności
    // Po upuszczeniu i zapisie przez serwer, serwer zwraca dymek GRID_RELOAD

    //console.log('... itemAdd .0.', item, this.rootItem)
    item = this.getItem(this.rootItem, item.id);
    if (!item) return;

    //console.log('... itemAdd .I.', item)
    //console.log('... itemAdd .L.', item.lastLocation)

    const parentId = item.lastLocation.program === 'else' ? item.lastLocation.parent?.bs4ItemElse?.id : item.lastLocation.parent?.bs4Item?.id;

    Bs4MainDispatch.commandParser('bs4SaveTrigger',{
      operation: 'add',
      command_type: item.element.id,
      'add_after': item.lastLocation.after?.bs4Item?.id || null,
      parent: parentId || null,
      currFormId: this.formId,
    }, this.bs4KartotekaId);
  }

  itemMove = (item) => {    
    //bs4SaveTrigger
    // ' command_id' - - id przeciąganej komendy z aplikacji (np. 1004234). Nie jest to id typu klocka.
    // ponadto 'add_after', 'parent', 'parentelse' tak samo jak w p.2
    // Jeśli przeciągamy gałąź, to przenosi wszystko w środku (także sekcję else)
    // Po upuszczeniu i zapisie przez serwer, serwer zwraca dymek GRID_RELOAD
    // console.log('... itemAdd .0.', item, this.rootItem)
    item = this.getItem(this.rootItem, item.id);
    if (!item) return;
    if (!item.bs4Item) {
      console.log('... itemMove .1. bs4Item?', item)
      return;
    }
    //console.log('... itemMove .I.', item)
    //console.log('... itemMove .L.', item.lastLocation)

    const parentId = item.lastLocation.program === 'else' ? item.lastLocation.parent?.bs4ItemElse?.id : item.lastLocation.parent?.bs4Item?.id;

    Bs4MainDispatch.commandParser('bs4SaveTrigger',{
      operation: 'move',
      command_id: item?.bs4Item?.id,
      //command_type: item.element.id,
      'add_after': item.lastLocation.after?.bs4Item?.id || null,
      parent: parentId || null,
      currFormId: this.formId,
    }, this.bs4KartotekaId);
  }

  itemDelete = (item) => {    
    //bs4SaveTrigger
    // ' command_id' - - id przeciąganej komendy z aplikacji (np. 1004234). Nie jest to id typu klocka.
    // ponadto 'add_after', 'parent', 'parentelse' tak samo jak w p.2
    // Jeśli przeciągamy gałąź, to przenosi wszystko w środku (także sekcję else)
    // Po upuszczeniu i zapisie przez serwer, serwer zwraca dymek GRID_RELOAD

    //item = this.getItem(this.rootItem, item.id);
    if (!item) return;
    if (!item.bs4Item) {
      console.log('... itemMove .1. bs4Item?', item)
      return;
    }

    console.log('... itemDelete ...', item)

    const parentId = item.lastLocation.program === 'else' ? item.lastLocation.parent?.bs4ItemElse?.id : item.lastLocation.parent?.bs4Item?.id;

    Bs4MainDispatch.commandParser('bs4SaveTrigger',{
      operation: 'delete',
      command_id: item?.bs4Item?.id,
      //command_type: item.element.id,
      'add_after': item.lastLocation.after?.bs4Item?.id || null,
      parent: parentId || null,
      currFormId: this.formId,
    }, this.bs4KartotekaId);
  }
  
  Droppable = ({children, ...props}) => {
    const report = this;
    const activeItem = React.useContext(this.ActiveItemContext);
    const {isOver, over, setNodeRef} = useDroppable({id: props.id});
    const active = activeItem && (activeItem.element.shape === SHAPE_ENDING && props.last || activeItem.element.shape !== SHAPE_ENDING)
    
    const sx = React.useMemo(() => {
      const sx = props.sx || {};
      if (isOver && active) {
        sx.minWidth = 0;
      } else {
        sx.minWidth = 100;
      }
      return sx;
    }, [isOver, active, props.sx])         
  
    return (
      <Box ref={setNodeRef} id={'Droppable_'+props.id} sx={sx}>          
        <Collapse in={isOver}>
          {isOver && active ? <report.ViewItem item={activeItem} only over try/> : null}
        </Collapse>
      </Box>
    );
  }

  DroppableDelete = ({children, ...props}) => {
    const report = this;
    const theme = useTheme();
    const activeItem = React.useContext(this.ActiveItemContext);
    const {isOver, over, setNodeRef} = useDroppable({id: props.id, });    
    const active = activeItem && activeItem.bs4Item;
    const backgroundColor = (isOver && active && activeItem?.element?.boxSx?.backgroundColor) ? alpha(activeItem?.element?.boxSx?.backgroundColor, 0.2) : null;

    return (
      <Box 
        ref={setNodeRef} 
        id={'Droppable_'+props.id} 
        sx={props.sx} 
        display='flex' 
        flexDirection='column' 
        alignItems='flex-start'
        //border='solid #ff0000'
        borderRadius={theme.shape.borderRadius+'px'}
        backgroundColor={backgroundColor}
      >
        {children}
        {isOver && active ? <report.ViewItem item={activeItem} only over try/> : null}
      </Box>
    );
  }

  Draggable = (props) => {
    const report = this;
    const {listeners, setNodeRef, setActivatorNodeRef} = useDraggable({id: props.id, disabled: props.disabled, data: props});
    
    const sx = props.sx || {};
    //sx.border = 'solid';

    const onPointerDown = listeners?.onPointerDown;  
    if (onPointerDown) listeners.onPointerDown = (event) => {      
      if (event?.target?.id === EDIT_VIEW_ID) return;
      onPointerDown(event);
    }

    return (
      <Box ref={setNodeRef} id={'Draggable_'+props.id} {...listeners} sx={sx}>
        {props.children}        
      </Box>
    );
  }
  
  dropShadow = 'drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.5))';

  getViewBox = (viewBox) => `${viewBox.x} ${viewBox.y} ${viewBox.width} ${viewBox.height}`;

  borderWidth = 2;
  marginTop = 30;
  marginLeft = 30;
  borderRadius = 4;
  tryColor = '#55555555';
  shapeDarken = 0.2;

  pathStart = () => ' m 0 '+this.borderRadius;

  pathLineH = (l, toContinue) => {
    l = Math.max(0, Math.abs(l) - 2 * this.borderRadius) * Math.sign(l);
    
    if (toContinue) {
      if (l > 0) return this.getLineToContinue()+' h '+(l-this.getLineToContinueLenght())+' ';
      if (l < 0) return ' h '+(l+this.getLineToContinueLenght())+' '+this.getLineToContinue(true);
    }
    return ' h '+l;
  };

  pathLineV = (l) => {
    l = Math.max(0, Math.abs(l) - 2 * this.borderRadius) * Math.sign(l);
    return ' v '+l;
  }

  pathCorner = (x, y, d) => {
    if (this.borderRadius === 0) return '';
    return ` a ${this.borderRadius} ${this.borderRadius} 0 0 ${d} ${x * this.borderRadius} ${y * this.borderRadius}`;
  }

  getItemId = (item, bs4Item) => {
    //return bs4Item?.id || ''+' ';
    //return item?.id || ''+' ';
    return '';
  }

  getItemText = (item, bs4Item) => {
    return bs4Item?.text || item?.element?.name || ''    
  }

  getBorderColor = (color) => {
    try{
      const borderColor = darken(color, this.shapeDarken);
      return borderColor
    } catch(error) {
      console.log('... DND getBorderColor darken ...', error);
      console.log('... DND getBorderColor darken ...', color, this.shapeDarken);
    }
    return color;
  }

  getMinWidth = () => {
    return this.getLineToContinueLenght() + 2 * this.borderRadius;
  }

  getMinHeight = () => {
    return Math.max(this.marginTop, 5, 2 * this.borderRadius);
  }

  getPaddingTop = () => {
    return Math.max(5, 2 * this.borderRadius)+'px';
  }

  getLineToContinueLenght = () => {
    const h = Math.max(15, 3 * this.borderRadius);
    return 3 * h - 2 * this.borderRadius;
  }

  getLineToContinue = (negative) => {
    const h = Math.max(15, 3 * this.borderRadius);
    const v = Math.max(5, 2 * this.borderRadius);
    let line = null;

    if (negative) line  = ' h '+(- h + 2 * this.borderRadius)
                        + this.pathCorner(-1, 1, 0)
                        + this.pathLineV(v)    
                        + this.pathCorner(-1, 1, 1)
                        + ' h '+(- h + 2 * this.borderRadius)
                        + this.pathCorner(-1, -1, 1)
                        + this.pathLineV(-v)
                        + this.pathCorner(-1, -1, 0)
                        + ' h '+(- h + 2 * this.borderRadius)
                        ;
    else line = ' h '+(h - 2 * this.borderRadius)
              + this.pathCorner(1, 1, 1)
              + this.pathLineV(v)    
              + this.pathCorner(1, 1, 0)
              + ' h '+(h - 2 * this.borderRadius)
              + this.pathCorner(1, -1, 0)
              + this.pathLineV(-v)
              + this.pathCorner(1, -1, 1)
              + ' h '+(h - 2 * this.borderRadius)
              ;

      return line;
  }

  ViewItemMessage = React.forwardRef((props, ref) => {
    const report = this;
    const className0 = "fa-solid fa-gear";
    const className1 = "fa-solid fa-gears";
    const className2 = "fa-solid fa-pen-to-square";
    return (
      <Stack ref={ref} direction="row" justifyContent="flex-start" alignItems="center" 
        sx={{
          paddingX: 1, 
          paddingY: 0.5, 
          position: 'relative',
          ...props.sx,
        }}
      >
        {props.onClick && props.bs4Item?.id ? 
          <IconButton id={EDIT_VIEW_ID} onClick={props.onClick} color='inherit' sx={{paddingRight: 1}}>
            <i id={EDIT_VIEW_ID} className={className0}/>
          </IconButton> 
          : null}        
        {props.item ? 
          <Box dangerouslySetInnerHTML={{__html: report.getItemId(props.item, props.bs4Item)+report.getItemText(props.item, props.bs4Item)}}/> 
          : null}
      </Stack>
    )
  });

  ViewItemStart = (props) => {
    const report = this;
    const refBox = React.useRef(null);
    const {item, sx, ...other} = props;    
    item.ref = refBox;
    const backgroundColor = props.try ? this.tryColor : item.element?.boxSx?.backgroundColor;
    const borderColor = this.getBorderColor(backgroundColor);
    const [path, setPath] = React.useState('m 0 0');    
    const [viewBox, setViewBox] = React.useState({x: 0, y: 0, width: 10, height: 10,});
    const activeItem = React.useContext(this.ActiveItemContext);
    const filter = (activeItem?.id === item.id) ? this.dropShadow : null;
    const topStart = 25;

    const calculatePath = () => {
      if (!refBox.current) return;
      
      const rectBox = refBox.current.getBoundingClientRect();
      const width = rectBox.width;
      const height = rectBox.height;
      
      viewBox.width = rectBox.width;
      viewBox.height = rectBox.height;      
      setViewBox({...viewBox});      

      setPath(' m 0 ' + (this.borderRadius + topStart)
            + ` q 0 ${- this.borderRadius - topStart} ${width / 2.0} ${- this.borderRadius - topStart} `
            + ` q ${width / 2.0} 0 ${width / 2.0} ${this.borderRadius + topStart} `
            + this.pathLineV(height - topStart)
            + this.pathCorner(-1, 1, 1) 
            + this.pathLineH(-width, true)
            + this.pathCorner(-1, -1, 1) 
            + this.pathLineV(-height + topStart)
      );
    }

    React.useEffect(() => {
      if (refBox.current) {
        new ResizeObserver((e) => calculatePath()).observe(refBox.current);
      }
    }, [refBox.current]);

    React.useEffect(() => calculatePath(), [this.borderRadius]);

    return (     
      <report.Draggable disabled id={item.id} sx={{overflow: 'visible'}}>
        <Box 
          ref={refBox} 
          position={'relative'} 
          sx={{
            overflow: 'visible', 
            color: item.element?.boxSx?.color, 
            paddingTop: topStart+'px', 
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg"
            style={{position:'absolute', left:0, top: 0, width: '100%', height: '100%', overflow: 'visible'}} 
            viewBox={report.getViewBox(viewBox)}
            preserveAspectRatio='none'
            filter={filter}
          >
            <path d={path} stroke={borderColor} strokeWidth={report.borderWidth} fill={backgroundColor} />
          </svg>
          <report.ViewItemMessage 
            item={item} 
            bs4Item={item.bs4Item} 
            sx={{
              minWidth: report.getMinWidth(),
              minHeight: report.getMinHeight(),
            }}
          />
        </Box>
      </report.Draggable>
    )
  }

  ViewItemRegular = (props) => {
    const report = this;
    const refBox = React.useRef(null);
    const {item, sx, ...other} = props;    
    item.ref = refBox;
    const backgroundColor = props.try ? this.tryColor : item.element?.boxSx?.backgroundColor;
    const borderColor = this.getBorderColor(backgroundColor);
    const [path, setPath] = React.useState('m 0 0');    
    const [viewBox, setViewBox] = React.useState({x: 0, y: 0, width: 10, height: 10,});
    const activeItem = React.useContext(this.ActiveItemContext);
    const filter = (activeItem?.id === item.id) ? this.dropShadow : null;

    const calculatePath = () => {
      if (!refBox.current) return;

      const rectBox = refBox.current.getBoundingClientRect();
      const width = rectBox.width; //Math.max((this.getLineToContinueLenght() + 2 * this.borderRadius + 5), ) - this.borderWidth;
      const height = rectBox.height;
      
      viewBox.width = rectBox.width;
      viewBox.height = rectBox.height;
      setViewBox({...viewBox});

     const path = this.pathStart() 
                + this.pathCorner(1, -1, 1)
                + this.pathLineH(width, true)
                + this.pathCorner(1, 1, 1) 
                + this.pathLineV(height)
                + this.pathCorner(-1, 1, 1) 
                + this.pathLineH(0 - width, true)
                + this.pathCorner(-1, -1, 1) 
                + this.pathLineV(0 - height)
                ;
      setPath(path);
    }

    React.useEffect(() => {
      if (refBox.current) {
        new ResizeObserver((e) => calculatePath()).observe(refBox.current);
      }
    }, [refBox.current]);

    React.useEffect(() => calculatePath(), [this.borderRadius]);

    return (     
      <report.Draggable id={item.id} sx={{overflow: 'visible'}}>
        <Box ref={refBox} position={'relative'} sx={{overflow: 'visible', color: item.element?.boxSx?.color}}>
          <svg xmlns="http://www.w3.org/2000/svg"
            style={{position:'absolute', left:0, top: 0, width: '100%', height: '100%', overflow: 'visible'}} 
            viewBox={report.getViewBox(viewBox)}
            preserveAspectRatio='none'
            filter={filter}
          >
            <path d={path} stroke={borderColor} strokeWidth={report.borderWidth} fill={backgroundColor} />
          </svg>
          <report.ViewItemMessage 
            item={item} 
            bs4Item={item.bs4Item} 
            onClick={() => report.itemClick(item.bs4Item)}
            sx={{
              paddingTop: report.getPaddingTop(),
              minWidth: report.getMinWidth(),
              minHeight: report.getMinHeight(),
            }}
          />
        </Box>
      </report.Draggable>
    )
  }

  ViewItemEnding = (props) => {const report = this;
    const refBox = React.useRef(null);
    const {item, sx, ...other} = props;    
    item.ref = refBox;
    const backgroundColor = props.try ? this.tryColor : item.element?.boxSx?.backgroundColor;
    const borderColor = this.getBorderColor(backgroundColor);
    const [path, setPath] = React.useState('m 0 0');    
    const [viewBox, setViewBox] = React.useState({x: 0, y: 0, width: 10, height: 10,});
    const activeItem = React.useContext(this.ActiveItemContext);
    const filter = (activeItem?.id === item.id) ? this.dropShadow : null;

    const calculatePath = () => {
      if (!refBox.current) return;

      const rectBox = refBox.current.getBoundingClientRect();
      const width = Math.max((this.getLineToContinueLenght() + 2 * this.borderRadius + 5), rectBox.width) - this.borderWidth;
      const height = rectBox.height;
      
      viewBox.width = rectBox.width;
      viewBox.height = rectBox.height;
      setViewBox({...viewBox});

      setPath(this.pathStart() 
            + this.pathCorner(1, -1, 1)
            + this.pathLineH(width, true)
            + this.pathCorner(1, 1, 1) 
            + this.pathLineV(height)
            + this.pathCorner(-1, 1, 1) 
            + this.pathLineH(0 - width)
            + this.pathCorner(-1, -1, 1) 
            + this.pathLineV(0 - height)
      );
    }

    React.useEffect(() => {
      if (refBox.current) {
        new ResizeObserver((e) => calculatePath()).observe(refBox.current);
      }
    }, [refBox.current]);

    React.useEffect(() => calculatePath(), [this.borderRadius]);

    return (     
      <report.Draggable id={item.id} sx={{overflow: 'visible'}}>
        <Box ref={refBox} position={'relative'} sx={{overflow: 'visible', color: item.element?.boxSx?.color}}>
          <svg xmlns="http://www.w3.org/2000/svg"
            style={{position:'absolute', left:0, top: 0, width: '100%', height: '100%', overflow: 'visible'}} 
            viewBox={report.getViewBox(viewBox)}
            preserveAspectRatio='none'
            filter={filter}
          >
            <path d={path} stroke={borderColor} strokeWidth={report.borderWidth} fill={backgroundColor}/>
          </svg>
          <report.ViewItemMessage 
            item={item} 
            bs4Item={item.bs4Item} 
            onClick={() => report.itemClick(item.bs4Item)}
            sx={{
              paddingTop: report.getPaddingTop(),
              minWidth: report.getMinWidth(),
              minHeight: report.getMinHeight(),
            }}
          />
        </Box>
      </report.Draggable>
    )    
  }

  isEnding = (item, program) => Boolean((item[item.programs[program]] || []).find(itemChild => itemChild.element.shape === SHAPE_ENDING));

  ViewItemtIf = (props) => {
    const report = this;
    const activeItem = React.useContext(this.ActiveItemContext);
    const refBox = React.useRef(null);
    const refIf = React.useRef(null);
    const refProg = React.useRef(null);    
    const refEndIf = React.useRef(null);
    const {item, sx, ...other} = props;    
    item.ref = refBox;
    const backgroundColor = props.try ? this.tryColor : item.element?.boxSx?.backgroundColor;
    const borderColor = this.getBorderColor(backgroundColor);
    const [path, setPath] = React.useState('m 0 0');    
    const [viewBox, setViewBox] = React.useState({x: 0, y: 0, width: 10, height: 10,});
    const filter = (activeItem?.id === item.id) ? this.dropShadow : null;

    const calculatePath = () => {
      if (!refBox.current || !refIf.current || !refEndIf.current) return;

      const rectBox = refBox.current.getBoundingClientRect();
      const rectIf = refIf.current.getBoundingClientRect();
      const rectProg = refProg.current.getBoundingClientRect();
      const rectEndIf = refEndIf.current.getBoundingClientRect();
      const heightIf = rectIf.height;
      const heightEndIf = rectEndIf.height;

      const width = rectBox.width;
      const height = rectBox.height;
      
      viewBox.width = rectBox.width;
      viewBox.height = rectBox.height;
      setViewBox({...viewBox});

      const path  = this.pathStart() 
                  + this.pathCorner(1, -1, 1)
                  + this.pathLineH(width, true)
                  + this.pathCorner(1, 1, 1) 
                  + this.pathLineV(heightIf)
                  + this.pathCorner(-1, 1, 1) 
                  + this.pathLineH(-(width - this.marginLeft), true)
                  + this.pathCorner(-1, 1, 0) 
                  + this.pathLineV(height - heightIf - heightEndIf)
                  + this.pathCorner(1, 1, 0) 
                  + this.pathLineH(width - this.marginLeft, !this.isEnding(item, 0))
                  + this.pathCorner(1, 1, 1) 
                  + this.pathLineV(heightEndIf)
                  + this.pathCorner(-1, 1, 1) 
                  + this.pathLineH(-width, true)
                  + this.pathCorner(-1, -1, 1) 
                  + this.pathLineV(-height)
      setPath(path);      
    }

    React.useEffect(() => {
      if (refBox.current && refIf.current, refEndIf) {
        const observer = new ResizeObserver((e) => calculatePath());
        observer.observe(refBox.current);
        observer.observe(refIf.current);
        observer.observe(refEndIf.current);        
      }
    }, [refBox.current, refIf.current]);

    React.useEffect(() => calculatePath(), [activeItem, this.borderRadius]);

    return (
      <report.Draggable id={item.id} sx={{overflow: 'visible'}}>
        <Box ref={refBox} position={'relative'} sx={{overflow: 'visible', color: item.element?.boxSx?.color}}>
          <svg xmlns="http://www.w3.org/2000/svg"
            style={{position:'absolute', left:0, top: 0, width: '100%', height: '100%', overflow: 'visible', color: item.element?.boxSx?.color}} 
            viewBox={report.getViewBox(viewBox)}
            preserveAspectRatio='none'
            filter={filter}
          >
            <path d={path} stroke={borderColor} strokeWidth={report.borderWidth} fill={backgroundColor}/>
          </svg>
          <Stack direction="column" justifyContent="flex-start" alignItems="flex-start" position={'relative'}>
            <report.ViewItemMessage 
              ref={refIf} 
              item={item} 
              bs4Item={item.bs4Item} 
              onClick={() => report.itemClick(item.bs4Item)}
              sx={{
                paddingTop: report.getPaddingTop(),
                minWidth: report.getMinWidth() + report.marginLeft,
                minHeight: report.getMinHeight(),
              }}
            />
            <report.ViewProgram ref={refProg} flex={1} item={item} program={item.programs[0]} {...other} sx={{marginLeft: report.marginLeft+'px', minHeight: report.getMinHeight()}}/>
            <report.ViewItemMessage 
              ref={refEndIf} 
              //item={item} 
              //bs4Item={item.bs4ItemEndIf} 
              //onClick={() => report.itemClick(item.bs4ItemEndIf)}
              sx={{
                paddingTop: report.getPaddingTop(),
                minWidth: report.getMinWidth() + report.marginLeft,
                minHeight: report.getMinHeight(),
              }}
            />
          </Stack>
        </Box>
      </report.Draggable>
    )
  }

  ViewItemtIfElse = (props) => {
    const report = this;
    const activeItem = React.useContext(this.ActiveItemContext);
    const refBox = React.useRef(null);
    const refIf = React.useRef(null);
    const refElse = React.useRef(null);    
    const refEndIf = React.useRef(null);
    const refProg0 = React.useRef(null);
    const refProg1 = React.useRef(null);
    const {item, sx, ...other} = props;    
    item.ref = refBox;    
    const backgroundColor = props.try ? this.tryColor : item.element?.boxSx?.backgroundColor;
    const borderColor = this.getBorderColor(backgroundColor);
    const [path, setPath] = React.useState('m 0 0');    
    const [viewBox, setViewBox] = React.useState({x: 0, y: 0, width: 10, height: 10,});
    const filter = (activeItem?.id === item.id) ? this.dropShadow : null;

    const calculatePath = () => {
      if (!refBox.current || !refIf.current || !refProg0.current || !refProg1.current) return;
      
      const rectBox = refBox.current.getBoundingClientRect();
      const rectIf = refIf.current.getBoundingClientRect();
      const rectElse = refElse.current.getBoundingClientRect();
      const rectEndIf = refEndIf.current.getBoundingClientRect();
      const rectProg0 = refProg0.current.getBoundingClientRect();
      const rectProg1 = refProg1.current.getBoundingClientRect();
      const heightIf = rectIf.height;
      const heightElse = rectElse.height;
      const heightEndIf = rectEndIf.height;
      const width = rectBox.width;
      const height = rectBox.height;
      const height0 = rectProg0.height;
      const height1 = rectProg1.height;
      
      
      viewBox.width = rectBox.width;
      viewBox.height = rectBox.height;
      setViewBox({...viewBox});

      setPath(this.pathStart() 
            + this.pathCorner(1, -1, 1)
            + this.pathLineH(width, true)
            + this.pathCorner(1, 1, 1) 
            + this.pathLineV(heightIf)
            + this.pathCorner(-1, 1, 1) 
            + this.pathLineH(0 - (width - this.marginLeft), true)            

            + this.pathCorner(-1, 1, 0) 
            + this.pathLineV(height0)
            + this.pathCorner(1, 1, 0) 
            + this.pathLineH(width - this.marginLeft, !this.isEnding(item, 0))
            + this.pathCorner(1, 1, 1) 
            + this.pathLineV(heightElse)
            + this.pathCorner(-1, 1, 1) 
            + this.pathLineH(0 - (width - this.marginLeft), true)

            + this.pathCorner(-1, 1, 0) 
            + this.pathLineV(height1)
            + this.pathCorner(1, 1, 0) 
            + this.pathLineH(width - this.marginLeft, !this.isEnding(item, 1))
            + this.pathCorner(1, 1, 1) 
            + this.pathLineV(heightEndIf)
            + this.pathCorner(-1, 1, 1) 

            + this.pathLineH(0 - width, true)
            + this.pathCorner(-1, -1, 1) 
            + this.pathLineV(0 - height)
      );
    }

    React.useEffect(() => {
      if (refBox.current && refIf.current && refProg0.current && refProg1.current) {
        const observer = new ResizeObserver((e) => calculatePath());
        observer.observe(refBox.current);
        observer.observe(refIf.current);
        observer.observe(refProg0.current);
        observer.observe(refProg1.current);        
      }
    }, [refBox.current, refIf.current, refProg0.current, refProg1.current]);

    React.useEffect(() => calculatePath(), [activeItem, this.borderRadius]);

    return (
      <report.Draggable id={item.id} sx={{overflow: 'visible'}}>
        <Box ref={refBox} position={'relative'} sx={{overflow: 'visible', color: item.element?.boxSx?.color}}>
          <svg xmlns="http://www.w3.org/2000/svg"
            style={{position:'absolute', left:0, top: 0, width: '100%', height: '100%', overflow: 'visible', color: item.element?.boxSx?.color}} 
            viewBox={report.getViewBox(viewBox)}
            preserveAspectRatio='none'
            filter={filter}
          >
            <path d={path} stroke={borderColor} strokeWidth={report.borderWidth} fill={backgroundColor}/>
          </svg>
          <Stack direction="column" justifyContent="flex-start" alignItems="flex-start" position={'relative'}>
            <report.ViewItemMessage 
              ref={refIf} 
              item={item} 
              bs4Item={item.bs4Item} 
              onClick={() => report.itemClick(item.bs4Item)}
              sx={{
                paddingTop: report.getPaddingTop(),
                minWidth: report.getMinWidth() + report.marginLeft,
                minHeight: report.getMinHeight(),
              }}
            />
            <report.ViewProgram ref={refProg0} flex={1} item={item} program={item.programs[0]} {...other} sx={{marginLeft: report.marginLeft+'px', minHeight: report.getMinHeight()}}/>      
            <report.ViewItemMessage 
              ref={refElse} 
              //item={item} 
              //bs4Item={item.bs4ItemElse} 
              //onClick={() => report.itemClick(item.bs4ItemElse)}
              sx={{
                paddingTop: report.getPaddingTop(),
                minWidth: report.getMinWidth() + report.marginLeft,
                minHeight: report.getMinHeight(),
              }}
            />
            <report.ViewProgram ref={refProg1} flex={1} item={item} program={item.programs[1]} {...other} sx={{marginLeft: report.marginLeft+'px', minHeight: report.getMinHeight()}}/>
            <report.ViewItemMessage 
              ref={refEndIf} 
              //item={item} 
              //bs4Item={item.bs4ItemEndIf} 
              //onClick={() => report.itemClick(item.bs4ItemEndIf)}
              sx={{
                paddingTop: report.getPaddingTop(),
                minWidth: report.getMinWidth() + report.marginLeft,
                minHeight: report.getMinHeight(),
              }}
            />
          </Stack>
        </Box>
      </report.Draggable>
    )
  }

  ViewItem = (props) => {
    const {item, tooltip, ...other} = props;
    const report = this;    
    const theme = useTheme();

    React.useEffect(() => {
      if (props.item?.trigger) {
        props.item.trigger(item.ref, null);
        delete props.item.trigger;
      }
    }, [props.item, props.item?.trigger])

    if (!props.item) return null;

    const getView = () => {
      switch(item.element.shape) {
        case 'start':   return <report.ViewItemStart    item={item} {...other}/>;
        case 'regular': return <report.ViewItemRegular  item={item} {...other}/>;
        case 'if':      return <report.ViewItemtIf      item={item} {...other}/>;
        case 'ifelse':  return <report.ViewItemtIfElse  item={item} {...other}/>;
        case 'ending':  return <report.ViewItemEnding   item={item} {...other}/>;
        default:        return <report.ViewItemRegular  item={item} {...other}/>;
      }  
    }

    const boxSx = {
      ...props.item?.element?.boxSx, 
      boxShadow: theme.shadows[3], 
      borderWidth: '0.5px', 
      borderStyle: 'solid', 
      borderColor: props.item?.element?.boxSx.color || null,
    };
    
    return (
      <Bs4HtmlTooltip
        boxsx={boxSx} 
        enterDelay={1000}
        enterTouchDelay={1000}
        enterNextDelay={1000}
        arrow
        placement='top'
        // followCursor={Boolean(props.overlay || resizeStart)}
        disableHoverListener={!Boolean(tooltip)}
        title={
          <Typography
            dangerouslySetInnerHTML={{__html: tooltip}}
            onClick={() => Bs4MainDispatch.commandParserAfter(this.bs4KartotekaId)}
            // onPointerDown={handlePointerDown}
          />
        }
      >
        <Box>{getView()}</Box>
      </Bs4HtmlTooltip>
    );
  }

  ViewLibrary = (props) => {
    const report = this;
    const theme = useTheme()
    const items = this.libraryItems;
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    };

    React.useEffect(() => { 
      this.seletCommand = (uxId, trigger) => {
        for (const item of items) {
          if (String(uxId) === String(item.id)) {
            item.trigger = trigger;
            setExpanded(item.element.section);
          }
        }        
      }
    }, [items]);

    return (      
      <Box overflow='auto' sx={props.sx} padding={1}>        
        {this.dragDropSection.sections.map(section => {
          const sectionItems = items.filter(item => item.element.section === section.id);
          const color = section?.boxSx?.color || '#000000';
          const backgroundColor = section?.boxSx?.backgroundColor || '#bbbbbb';
          const borderColor = this.getBorderColor(backgroundColor)
          const backgroundColorDetails = lighten(backgroundColor, 0.8);
          return (
            <Accordion 
              key={section.id} 
              expanded={expanded === section.id} 
              onChange={handleChange(section.id)} 
              //sx={{color: color, backgroundColor: backgroundColor , overflow: 'hidden'}}
              //sx={{backgroundColor: backgroundColorDetails}}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={2}>
                  <Box 
                    sx={{
                      color: color, 
                      backgroundColor: 
                      backgroundColor, 
                      borderColor: borderColor, 
                      borderStyle: 'solid', 
                      borderWidth: this.borderWidth,
                      borderRadius: '999px',
                      p: 2,                       
                      }}
                  />
                  <Typography>{section.name}</Typography>
                  </Stack>
              </AccordionSummary>
              <AccordionDetails>
                <Box display='flex' flexDirection='column' alignItems='flex-start' p={1} gap={2} width='100%'>
                  {sectionItems.map(item => <report.ViewItem key={item.id} item={item} tooltip={item.element?.tooltip} only library/>)}
                </Box>
              </AccordionDetails>
            </Accordion>
          )
        })}  
      </Box>            
    )
  }

  ViewProgram = React.forwardRef((props, ref) => {
    let {item, program, only} = props;
    const report = this;
    const lastItem = (item[program] || []).length - 1;
    const items = item[program] || [];
    const start = items[0]?.element.shape === 'start';
    //only = true;

    return (
      <Box ref={ref} display='flex' flexDirection='column' alignItems='flex-start' minHeight={25} sx={props.sx}>
        {!only && !start ? <report.Droppable id={item.id+ID_SEPARATOR+program} last={lastItem < 0}/> : null}
        {items.map((itemChild, index) => {
          const last = lastItem === index;
          return (
            <React.Fragment key={itemChild.id}>
              <report.ViewItem item={itemChild} only={only} tooltip={itemChild?.bs4Item.tooltip}/>
              {!only && itemChild.element.shape !== SHAPE_ENDING
              ? <report.Droppable id={item.id+ID_SEPARATOR+program+ID_SEPARATOR+itemChild.id} last={last}/>
              : null}
            </React.Fragment>
          )
        })}
      </Box>
    )
  });

  setDataToRoot = (parent, data, program) => {
    program = program || 0;
    if (!data) return;
    let previous  = null;
    for (const bs4Item of data) {
      if (bs4Item.command_type === '14') {
        if (['10', '16', '21', '104', '19'].includes(previous?.bs4Item?.command_type)) {
          previous.bs4ItemEndIf = bs4Item;
        } else {
          console.log('... setDataToRoot ... error lost EndIf', bs4Item);
        }
        continue;
      }      

      if (bs4Item.command_type === '12' && previous?.bs4Item?.command_type === '21') {
        previous.bs4ItemElse = bs4Item;
        this.setDataToRoot(previous, bs4Item.children, 1);
        continue;
      }

      const element = this.dragDropSection.elements.find(element => String(element.id) === String(bs4Item.command_type));      
      if (!element) {
        console.log('... setDataToRoot ... no element', bs4Item);
        continue;
      }
            
      const item = this.newItem(element, this.getNextIdItem());
      item.bs4Item = bs4Item;
      //console.log('... setDataToRoot ... ', bs4Item, item);
      parent[parent.programs[program]].push(item);
      this.setDataToRoot(item, bs4Item.children)
      previous = item;
    }
  }

  getBs4Item = (id, items) => {
    for (const item of items) {
      if (String(item.id) === String(id)) return item;
      for (const program of item.programs) {
        const programItem = this.getBs4Item(id, item[program]);
        if (programItem) return programItem;
      }
    }
  }

  showTooltip = () => {

  }

  ViewComponent = React.forwardRef((props, ref) => {
    const report = this;
    const [root, setRoot] = React.useState(this.rootItem);
    const theme = useTheme();
    this.borderRadius = theme.shape.borderRadius;
    const [update, setUpdate] = React.useState(0);
    const [activeItem, setActiveItem] = React.useState(null)
    const _ = React.useMemo(() => {
      this.dragDropSection.elements.forEach(element => {
        element.boxSx = getBoxSx(element.color, theme)
      });
      this.dragDropSection.sections.forEach(section => {
        section.boxSx = getBoxSx(section.color, theme)
      });
      //console.log('....DND boxSx...', this.dragDropSection)
      return null;
    }, [theme]);

    const sensors = useSensors(
      useSensor(PointerSensor, {
        activationConstraint: {
          //distance: 10,
          //delay: 100,
          //tolerance: 15,
        },
      })
    );
    
    React.useEffect(() => { 
      this.showTooltip = (id) => {
        const bs4Item = this.getBs4Item(id, root.main);
        // console.log('...showTooltip...Trigger...', id, root, bs4Item);
        return bs4Item
      }            
    }, [root]);

    React.useEffect(() => {       
      this.setData = (newData) => {        
        this.rootItem = this.newItem({color: "", id: -1, name: "Main", section: -1, shape: "main"});
        this.setDataToRoot(this.rootItem, newData);
        console.log('...program trigger...', newData)
        setRoot(this.rootItem)
      }
      this.fetchMore();
    }, [])

    const handleDragStart = (event) => {      
      //console.log('...DragStart..', event)
      const item = this.libraryItems.find(item => item.id === event.active.id)
      if (item) {
        const newItem = this.newItem(item.element);
        setActiveItem(newItem);        
        //console.log('...DragStart...lib', event.active.id, newItem, item);
      } else {
        const item = this.removeItem(root, event.active.id);
        //console.log('...DragStart...removed', item)
        if (item) {
          setActiveItem(item);
          //setUpdate(update + 1);
        } else {
          console.log('...DragStart...error', event)
          return;
        }        
      }
    }

    const handleDragEnd = (event) => {
      console.log('...DragEnd...', event);
      if (event.over && event.active && activeItem) {           
        const itemLib = this.libraryItems.find(item => item.id === event.active.id)
        //console.log('...DragEnd...lib', event.active.id, activeItem, itemLib);
        if (event.over.id === "Delete")  {
          // if (activeItem.lastLocation && activeItem.bs4Item.id) {
          //   const id = activeItem.lastLocation.parent.id;
          //   const program = activeItem.lastLocation.program;
          //   const afterId = activeItem.lastLocation.after?.id;        
          //   this.insertItem(this.rootItem, id, program, afterId, activeItem);
          // }
          this.itemDelete(activeItem);
          setActiveItem(null);
          setUpdate(update + 1);
          return;
        }
        const [id, program , afterId] = event.over.id.split(ID_SEPARATOR);
        if (!activeItem.bs4Item) activeItem.bs4Item = {id: null};
        this.insertItem(this.rootItem, id, program, afterId, activeItem);
        //console.log('...DragEnd...inserted', activeItem, this.rootItem);
        setUpdate(update + 1);
        //console.log('...DragEnd...Library ? ', event.active.id, itemLib, activeItem);
        if (itemLib) {
          itemLib.id = this.getNextIdItem();
          this.itemAdd(activeItem);
        } else {
          this.itemMove(activeItem);
        }
      } else if (activeItem.lastLocation) {
        const id = activeItem.lastLocation.parent.id;
        const program = activeItem.lastLocation.program;
        const afterId = activeItem.lastLocation.after?.id;        
        this.insertItem(this.rootItem, id, program, afterId, activeItem);
      }
      if (activeItem) delete activeItem.lastLocation;
      setActiveItem(null);
    }

    const handleDragOver = (event) => {
      //console.log('...DragOver...', event.over?.id, event.active?.id, event)
    }

    const handleDragCancel = (event) => {
      //console.log('...DragCancel...', event.active?.id, event)
      if (activeItem?.lastLocation) {
        const id = activeItem.lastLocation.parent.id;
        const program = activeItem.lastLocation.program;
        const afterId = activeItem.lastLocation.after?.id;
        this.insertItem(this.rootItem, id, program, afterId, activeItem);        
      }
      if (activeItem) delete activeItem.lastLocation;
      setActiveItem(null);
    }

    console.log('...DND...View..', activeItem, root)

    return (
      <Box ref={ref} height='100%' width='100%' display='flex' flexDirection="column" overflow='hidden' px={props.uxKartoteka?.spacing}>
        <Box display="flex" flexDirection="row" flexWrap='wrap' gap='6px' p={0.5} alignItems='center'>
          <Bs4Criteria {...report.props}/>
          <report.ReportBs4HorizontalMenu onMenuClick={report.handleMenuClick} setMenu={report.setReportOptionMenu}/>
        </Box>
        <Box pt={props.uxKartoteka?.spacing / 3}/>
        <Bs4CriteriaSummary {...report.props}/>                
        <DndContext 
          onDragStart={handleDragStart}
          onDragEnd={handleDragEnd} 
          onDragOver={handleDragOver}
          onDragCancel={handleDragCancel}
          //collisionDetection={closestCenter}
          collisionDetection={report.customCollisionDetectionAlgorithm}
          sensors={sensors}
        >
          <report.ActiveItemContext.Provider value={activeItem}>
            <Box flex={1} display='flex' flexDirection='row' overflow='hidden'>
              <report.ViewLibrary sx={{width: '30%'}}/>
              <report.ViewProgram item={root} program={root.programs[0]} sx={{width: '70%', overflow:'auto', p: 5}}/>            
            </Box>
            <DragOverlay> {activeItem ? <report.ViewItem item={activeItem} only over/> : null} </DragOverlay>
            <Box>
              <report.DroppableDelete id='Delete' sx={{p: 2}}>
                <Typography variant='h5'>
                  <i className="fa-solid fa-trash"/>
                  &nbsp; &nbsp;
                  {report.text_Delete}
                </Typography>                                
              </report.DroppableDelete>
            </Box>
          </report.ActiveItemContext.Provider>
        </DndContext>  
      </Box>
    )
  });
}